import { render, staticRenderFns } from "./ReComments.vue?vue&type=template&id=3f34ae04&"
import script from "./ReComments.vue?vue&type=script&lang=js&"
export * from "./ReComments.vue?vue&type=script&lang=js&"
import style0 from "./ReComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports